var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showAd)?_c('b-navbar',{attrs:{"toggleable":"lg","type":"dark","variant":"dark"}},[_c('b-navbar-brand',[_c('img',{staticClass:"notif-img",attrs:{"src":require("../assets/notif-img.jpg")}})])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }